module.exports = __webpack_public_path__ + "static/media/iphone_14.1bdb061c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple/iphone_14.png
// module id = 1134
// module chunks = 0